<template>
  <div :class="className" :id="id" :style="{ height: height, width: width}" />
</template>

<script>
export default {
  name: "AmapHeatmap",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Array
    },
    center: {
      type: Array
    }
  },
  data() {
    return {
      chart: null,
      map: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption({
        amap: {
          //maxPitch: 60,
          //pitch: 0, //45 俯仰角
          //viewMode: "3D",
          zoom: 9,
          dragEnable: false,
          doubleClickZoom: false,
          expandZoomRange: false,
          zoomEnable: false,
          zooms: [8, 10],
          mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4', //地图主题
          center: this.center, //中心点
          rotation: 0, //顺时针旋转角度
          resizeEnable: true
        },
        animation: false,
        visualMap: {
          show: false,
          text: ["图例", ""],
          textGap: 10,
          min: 10,
          max: 100,
          left: 10,
          bottom: 5,
          //inverse: true,
          calculable: true,
          color: ["#ff3333", "orange", "yellow", "lime", "aqua"],
          textStyle: {
            color: "#fff"
          }
        },
        series: []
      });

      // 上面的部分是echarts的配置，需要注意的是amap，这里的配置就是针对 高德地图 的配置了，而支持哪些配置
      // 可以去高德地图的开发平台去查看

      this.map = this.chart
        .getModel()
        .getComponent("amap")
        .getAMap();
      // var layer = myChart
      //   .getModel()
      //   .getComponent("amap")
      //   .getLayer();
      // var series = [];

      // myChart.setOption({
      //   series: series
      // });
      this.chart.setOption({
        series: [
          {
            type: "heatmap",
            coordinateSystem: "amap",
            blurSize: 20,
            minOpacity: 0,
            maxOpacity: 1,
            data: this.chartData
          }
        ]
      });

      //下面是确保高德地图渲染的时候，echarts同时也需要再次渲染一次，保持位置的同步
      // layer.render = function() {
      //   // let series = myChart.getOption().seriesIndexes;
      //   // myChart.setOption({
      //   //     series: []
      //   // });
      //   myChart.setOption({
      //     series: series
      //   });

      //   console.log("当前缩放级别：" + map.getZoom());
      //   console.log("俯视视角：" + map.getPitch());
      //   console.log("顺时针：" + map.getRotation());
      // };
    }
  },
  watch: {
    center: function() {
      //this.chart.dispose();
      //this.chart = null;
      this.map.panTo(this.center);
      this.initChart();
    }
  }
};
</script>
<style scoped lang="less"></style>
